import React from "react";
import * as Yup from "yup";
import "leaflet/dist/leaflet.css";

import TruckForm from "./TruckForm";

function LocationForm(props) {
  return (
    <div className="create-product">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2>Mes camions - Ajouter un camion</h2>

            <TruckForm
              initialValues={{
                fuel: "",
                registration: "",
                carteGrise: false,
                price: "",
                images: {},
                cities: {},
                dates: {},
                enabled: "",
                category: "",
              }}
              validationSchema={Yup.object().shape({
                category: Yup.string().required("La catégorie est requise."),
                fuel: Yup.string().required("Le carburant est requis."),
                registration: Yup.string().required(
                  "La plaque d'immatriculation est requise."
                ),
                carteGrise: Yup.boolean().required(
                  "La carte grise est requise."
                ),
                price: Yup.number().required("Le prix est requis."),
              })}
              props={props}
              isCreate={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationForm;
